import { ShipmentBranchSelect } from '@/views/screens/Shipment';
import { CountrySelect, CurrencySelect, StateSelect } from '@/views/screens/common';
import { Col, Form, Row } from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE } from '../../../../../../../contants/ClaimsEnums';
import { setWarningModal } from '../../../../../../../redux/common/CommonActions';
import FormDatePicker from '../../../../../../components/Inputs/FormDatePicker';
import FormInput from '../../../../../../components/Inputs/FormInput';
import FormTextArea from '../../../../../../components/Inputs/FormTextArea';
import HiddenFormInput from '../../../../../../components/Inputs/HiddenFormInput';
import TransportationProviderSelector from '../../../../../../components/Selectors/AsynchSearch/TransportationProviderSelector';
import PostalCodeInput from '../../../../../../components/Selectors/PostalCodeInput';
import PreClaimsReasonSelector from '../../../../../../components/Selectors/PreClaimsReasonSelector';
import PreClaimsReasonTypeSelector from '../../../../../../components/Selectors/PreClaimsReasonTypeSelector';
import PreClaimsShipperConsigneeShortName from '../../../../../../components/Selectors/PreClaimsShipperConsigneeShortName';
import PreClaimsTypeSelector from '../../../../../../components/Selectors/PreClaimsTypeSelector';

const PreClaimsDetailsForm = ({
  detailsForm,
  editMode = true,
  initiateSubmitProcess,
  onFieldsChange,
  initialValues,
}) => {
  const { selectedCompany } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const consigneeCountry = Form.useWatch('consigneeCountry', detailsForm);
  const shipperCountry = Form.useWatch('shipperCountry', detailsForm);

  const handleConsigneeZipEntry = (data) => {
    detailsForm.setFieldsValue({
      consigneeZip: data?.zip,
      consigneeState: data?.state,
      consigneeCity: data?.city,
    });
  };

  const handleShipperZipEntry = (data) => {
    detailsForm.setFieldsValue({
      shipperZip: data?.zip,
      shipperState: data?.state,
      shipperCity: data?.city,
    });
  };

  const handleConsigneeFetch = (type, data) => {
    let consigneeData = {};
    consigneeData.countryCode = initialValues?.consigneeCountry;
    if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.SUCCESS) {
      consigneeData = data;
    } else if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.EMPTY) {
      dispatch(setWarningModal({ open: true, description: 'No data found' }));
    } else if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.CLEAR) {
    } else if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.ERROR) {
      dispatch(
        setWarningModal({
          open: true,
          description: 'Error while fetching data',
        }),
      );
    }
    detailsForm.setFieldsValue({
      consigneeName: consigneeData?.consigneeShipperName,
      consigneeAddr1: consigneeData?.addr1,
      consigneeAddr2: consigneeData?.addr2,
      consigneeCountry: consigneeData?.countryCode,
      consigneeZip: consigneeData?.zip,
      consigneeState: consigneeData?.state,
      consigneeCity: consigneeData?.city,
      consigneeKey: consigneeData?.claimShipRecKey,
    });
  };

  const consigneeKey = Form.useWatch('consigneeKey', detailsForm);

  const handleShipperFetch = (type, data) => {
    let consigneeData = {};
    consigneeData.countryCode = initialValues?.shipperCountry;
    if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.SUCCESS) {
      consigneeData = data;
    } else if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.EMPTY) {
      dispatch(setWarningModal({ open: true, description: 'No data found' }));
    } else if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.CLEAR) {
    } else if (type === CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.ERROR) {
      dispatch(
        setWarningModal({
          open: true,
          description: 'Error while fetching data',
        }),
      );
    }
    detailsForm.setFieldsValue({
      shipperName: consigneeData?.consigneeShipperName,
      shipperAddr1: consigneeData?.addr1,
      shipperAddr2: consigneeData?.addr2,
      shipperCountry: consigneeData?.countryCode,
      shipperZip: consigneeData?.zip,
      shipperState: consigneeData?.state,
      shipperCity: consigneeData?.city,
      originKey: consigneeData?.claimShipRecKey,
    });
  };

  const originKey = Form.useWatch('originKey', detailsForm);

  return (
    <Form name="detailsForm" form={detailsForm} onFieldsChange={onFieldsChange} initialValues={initialValues}>
      <Row gutter={15}>
        <Col sm={6}>
          <CurrencySelect
            margin="mb-15"
            editMode={editMode}
            name="currencyCode"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={1}
            rules={[
              {
                required: true,
                message: 'Please select a Currency',
              },
            ]}
          />
          <TransportationProviderSelector
            margin="mb-15"
            form={detailsForm}
            showPopupFilter
            label="Transportation Provider"
            name="carrierKey"
            // inputValue={carrierKey}
            // carrierName={carrierName}
            // onChange={handleCarrierChange}
            disableOpen
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={2}
            rules={[
              {
                required: true,
                message: 'Please select a Transportation Provider',
              },
            ]}
          />
          <PreClaimsShipperConsigneeShortName
            margin="mb-15"
            label="Consignee Short Name"
            name="consigneeShortName"
            editMode={editMode}
            onFetch={handleConsigneeFetch}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={3}
            maxLength={9}
          />
          <FormInput
            margin="mb-15"
            label="Consignee"
            name="consigneeName"
            editMode={editMode && !consigneeKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={4}
            maxLength={30}
            rules={[
              {
                required: true,
                message: 'Please enter the Consignee Name',
              },
            ]}
          />
          <FormTextArea
            margin="mb-15"
            label="Address"
            name="consigneeAddr1"
            editMode={editMode && !consigneeKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={5}
            rows={2}
            rules={[
              {
                required: true,
                message: 'Please enter the Address',
              },
            ]}
            maxLength={35}
          />
          <FormTextArea
            margin="mb-15"
            label="Address 1"
            name="consigneeAddr2"
            editMode={editMode && !consigneeKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={6}
            rows={2}
            maxLength={35}
          />
          <CountrySelect
            margin="mb-15"
            label="Country"
            name="consigneeCountry"
            editMode={editMode && !consigneeKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={7}
            rules={[
              {
                required: true,
                message: 'Please select a country',
              },
            ]}
          />
          <PostalCodeInput
            margin="mb-15"
            label="Postal Code"
            name="consigneeZip"
            editMode={editMode && !consigneeKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={8}
            rules={[
              {
                required: true,
                message: 'Please enter Consignee postal code',
              },
            ]}
            countryCode={consigneeCountry}
            handleZipDetails={handleConsigneeZipEntry}
            maxLength={10}
          />
          <StateSelect
            margin="mb-15"
            label="State"
            name="consigneeState"
            editMode={false}
            rules={[
              {
                required: true,
                message: 'Please select a state',
              },
            ]}
            countryCode={consigneeCountry}
          />
          <FormInput
            margin="mb-0"
            label="City"
            name="consigneeCity"
            editMode={false}
            rules={[
              {
                required: true,
                message: 'Please enter city',
              },
            ]}
          />
        </Col>
        <Col sm={6}>
          <PreClaimsTypeSelector
            name="claimTypeKey"
            margin="mb-10"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={9}
            rules={[
              {
                required: true,
                message: 'Please select a claim Type',
              },
            ]}
          />
          <FormDatePicker
            margin="mb-15"
            label="Ship Date"
            name="dateShipped"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={10}
            rules={[
              {
                required: true,
                message: 'Please select Ship Date',
              },
            ]}
            disabledTargetDate={moment().add(1, 'days').toDate()}
            disableFuture
          />
          <FormInput
            margin="mb-15"
            label="Pieces"
            name="claimNoOfPieces"
            editMode={editMode}
            inputType="number"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={11}
          />
          <PreClaimsReasonTypeSelector
            name="reasonType"
            margin="mb-10"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={12}
            rules={[
              {
                required: true,
                message: 'Please select a claim Reason Type',
              },
            ]}
          />
        </Col>
        <Col sm={6}>
          <ShipmentBranchSelect
            label="Branch"
            name="branchKey"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={13}
            margin="mb-10"
            rules={[
              {
                required: true,
                message: 'Please select a claim Branch',
              },
            ]}
            customerId={selectedCompany.companyId}
          />

          <PreClaimsShipperConsigneeShortName
            margin="mb-15"
            label="Shipper Short Name"
            name="shipperShortName"
            editMode={editMode}
            onFetch={handleShipperFetch}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={14}
            maxLength={9}
          />
          <FormInput
            margin="mb-15"
            label="Shipper"
            name="shipperName"
            editMode={editMode && !originKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={15}
            rules={[
              {
                required: true,
                message: 'Please enter the Shipper Name',
              },
            ]}
            maxLength={30}
          />
          <FormTextArea
            margin="mb-15"
            label="Address"
            name="shipperAddr1"
            editMode={editMode && !originKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={16}
            rows={2}
            rules={[
              {
                required: true,
                message: 'Please enter the Address',
              },
            ]}
            maxLength={35}
          />
          <FormTextArea
            margin="mb-15"
            label="Address 1"
            name="shipperAddr2"
            editMode={editMode && !originKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={17}
            rows={2}
            maxLength={35}
          />
          <CountrySelect
            margin="mb-15"
            label="Country"
            name="shipperCountry"
            editMode={editMode && !originKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={18}
            rules={[
              {
                required: true,
                message: 'Please select a country',
              },
            ]}
          />
          <PostalCodeInput
            margin="mb-15"
            label="Postal Code"
            name="shipperZip"
            editMode={editMode && !originKey}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={19}
            rules={[
              {
                required: true,
                message: 'Please enter Shipper Postal Code',
              },
            ]}
            countryCode={shipperCountry}
            handleZipDetails={handleShipperZipEntry}
            maxLength={10}
          />
          <StateSelect
            margin="mb-15"
            label="State"
            name="shipperState"
            editMode={false}
            rules={[
              {
                required: true,
                message: 'Please select a state',
              },
            ]}
            countryCode={shipperCountry}
          />
          <FormInput
            margin="mb-0"
            label="City"
            name="shipperCity"
            editMode={false}
            rules={[
              {
                required: true,
                message: 'Please enter city',
              },
            ]}
          />
        </Col>
        <Col sm={6}>
          <FormInput
            margin="mb-15"
            label="Invoice Number"
            name="invoiceNo"
            editMode={editMode}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={20}
            maxLength={25}
            rules={[
              {
                required: true,
                message: 'Please enter Invoice Number',
              },
            ]}
            onBlur={() => initiateSubmitProcess(true, 'invoiceNo')}
          />
          <FormInput
            margin="mb-15"
            label="Freight Bill / Pro Number"
            name="claimProNo"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={21}
            editMode={editMode}
            rules={[
              {
                required: true,
                message: 'Please enter Freight Bill / Pro Number',
              },
            ]}
            maxLength={25}
            onBlur={() => initiateSubmitProcess(true, 'claimProNo')}
          />
          <FormInput
            margin="mb-15"
            label="Chargeable Weight"
            name="cargoShipmentWeight"
            editMode={editMode}
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={22}
            inputType="number"
            rules={[
              {
                required: true,
                message: 'Please enter Chargeable Weight',
              },
              () => ({
                validator(_, value) {
                  if (value <= 0) {
                    return Promise.reject(new Error('Chargeable weight should be grater than zero'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          />
          <PreClaimsReasonSelector
            name="reasonCode"
            // biome-ignore lint/a11y/noPositiveTabindex: <explanation>
            tabIndex={23}
            margin="mb-10"
            rules={[
              {
                required: true,
                message: 'Please select a claim Reason',
              },
            ]}
          />
        </Col>
        <HiddenFormInput name="consigneeKey" />
        <HiddenFormInput name="originKey" />
        <HiddenFormInput name="claimStatusCode" />
      </Row>
    </Form>
  );
};

export default PreClaimsDetailsForm;
